import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      height: '1px',
      flex: 'auto',
      background: palette.background.dark
    },
    large: {
      height: '2px'
    },
    light: {
      background: palette.background.underBox
    },
    margin: {
      marginBottom: '10px'
    },
    vertical: {
      flex: 'none',
      height: 'auto',
      width: '1px',
      margin: '0'
    },
    bottomMenu: {
      flex: '1',
      width: '0',
      background: 'transparent',
      borderLeft: '2px dashed #959595'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
